import React from "react"
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"
import { useMultipleUsers } from "Pages/Admin/Users/@hooks"
import { USER_MULTI_OPTIONS } from "Pages/Admin/Users/@constans"

export default function MultipleUserSelect({ selectedData, setSelectedRows }) {

	const { handleOpenModal } = useMultipleUsers(selectedData, setSelectedRows)

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mr: 2 }}>
		<ButtonIconSeeker
			icon="arrow-right-to-city"
			sx={{
				color: "secondary.light"
			}}
			tooltip="Edit multiple users offices"
			onClick={() => handleOpenModal(USER_MULTI_OPTIONS.OFFICE)}
		/>
		<ButtonIconSeeker
			icon="globe-pointer"
			sx={{
				color: "secondary.light"
			}}
			tooltip="Edit multiple users sites"
			onClick={() => handleOpenModal(USER_MULTI_OPTIONS.SITE)}
		/>
		<ButtonIconSeeker
			icon="user-tie"
			sx={{
				color: "secondary.light"
			}}
			tooltip="Edit multiple users masters"
			onClick={() => handleOpenModal(USER_MULTI_OPTIONS.MASTERS)}
		/>
	</Box>
}